<template>
  <div class="cling-slider" @click="onClick">
      <div class="cling-slider__line"></div>
      <div class="cling-slider__line past" :style="{width: positionInPercent}"></div>
      <div class="cling-slider__handle" :style="{left: positionInPercent}" @mousedown.stop="onMouseDown">
        <i aria-hidden="true"></i>
      </div>
      <span v-if="showValue" class="value">{{Math.round(value)}}{{valueType}}</span>
  </div>
</template>

<script>
export default {
  name: 'clingSlider',

  props: {
    value: {
      type: Number,
      default: 1
    },

    min: {
      type: Number,
      default: 0
    },

    max: {
      type: Number,
      default: 1
    },
    valueType: {
      type: String,
      default: "%"
    },
    showValue: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    positionInPercent: function () {
      return (this.value - this.min) / this.range * 100 + '%';
    },

    range: function () {
      return this.max - this.min;
    },

    widthInPixel: function () {
      return this.$el.getBoundingClientRect().width;
    },

    leftInPixel: function () {
      return this.$el.getBoundingClientRect().left;
    }
  },

  beforeDestroy() {
    document.body.removeEventListener('mousemove', this.onMouseMove)
    document.body.removeEventListener('mousemove', this.onMouseUp)
  },

  methods: {
    getInputValue: function (value) {
      value = ((value - this.leftInPixel) / this.widthInPixel) * this.range + this.min

      if (value < this.min) {
        value = this.min;
      } else if (value > this.max) {
        value = this.max;
      }
      return value;
    },

    onClick(e) {
      this.emitInput(this.getInputValue(e.clientX));
    },

    onMouseDown: function (e) {
      document.body.addEventListener('mousemove', this.onMouseMove)
      document.body.addEventListener('mouseup', this.onMouseUp)

      this.emitInput(this.getInputValue(e.clientX));
    },

    onMouseUp: function (e) {
      document.body.removeEventListener('mousemove', this.onMouseMove)
      document.body.removeEventListener('mouseup', this.onMouseUp)

      this.emitInput(this.getInputValue(e.clientX));
    },

    onMouseMove: function (e) {
      this.emitInput(this.getInputValue(e.clientX));
    },

    emitInput: function (newValue) {
      this.$emit('input', newValue);
    }
  }
}
</script>